<template>
    <div class="uik-prompt">
        <UikPopup
            v-if="visible"
            ref="wrapper"
            :visible="visible"
            :maxWidth="500"
            tabindex="0"
            @close="$emit('close', payload)"
            @confirm="confirm()"
        >
            <UikTopBarTitle is="h2" class="uik-prompt__headline">{{ title }}</UikTopBarTitle>
            <div
                :class="{'uik-prompt__message--confirm-input': confirmInput}"
                class="uik-popup__section uik-prompt__message">
                <p>{{ message }}</p>
            </div>
            <div v-if="confirmInput" class="uik-popup__section uik-prompt__confirm-input">
                <UikInput
                    v-model="confirmInputValue"
                    :placeholder="confirmInputPlaceholder"
                    @input="confirmInputValue == confirmInput ? confirm():false"/>
            </div>
            <div
                v-if="(this.confirmInput && this.cancelBtn) || (!this.confirmInput && (this.confirmBtn || this.cancelBtn))"
                class="uik-popup__section uik-prompt__button-container">
                <UikButton
                    v-if="cancelBtn"
                    :text="cancelBtn"
                    class="uik-prompt__cancel-button"
                    @click="$emit('close', payload)"/>
                <UikButton
                    v-if="!confirmInput"
                    :text="confirmBtn"
                    class="uik-prompt__confirm-button"
                    :success="confirmBtnColor == 'success'"
                    :primary="confirmBtnColor == 'primary'"
                    :error="confirmBtnColor == 'error'"
                    @click="confirm()"/>
            </div>
        </UikPopup>
        <UikOverlay :visible="visible" @close="$emit('close', payload)"/>
    </div>
</template>

<script>
export default {
    name: "UikPrompt",
    props: {
        title: {
            type: String,
            default: "Prompt Popup",
            required: true
        },
        message: {
            type: String,
            default: "Message",
            required: true
        },
        confirmBtn: {
            type: String,
            default: "Continue"
        },
        cancelBtn: {
            type: String,
            default: ""
        },
        confirmBtnColor: {
            type: String,
            default: "success",
            validator: value => {
                let options = [
                    "success",
                    "primary",
                    "error"
                ]
                return options.includes(value)
            }
        },
        confirmInput: {
            type: String,
            default: ""
        },
        confirmInputPlaceholder: {
            type: String,
            default: ""
        },
        visible: {
            type: Boolean,
            required: true
        },
        payload: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            confirmInputValue: ""
        }
    },
    methods: {
        confirm () {
            this.$emit("confirm", this.payload)
        }
    }
}
</script>

<style lang="scss">
    .uik-prompt {
        position: relative;
        z-index: 2000;
        .uik-popup__close {
            top: 27px !important;
            right: 25px !important;
        }
        .uik-prompt__headline {
            padding: 5px 45px 15px 25px !important;
        }
        .uik-prompt__message {
            padding: 30px !important;
            p {
                color: $textMain;
            }
        }
        .uik-prompt__message--confirm-input {
            border: none !important;
            padding-bottom: 0 !important;
        }
        .uik-prompt__button-container {
            padding: 20px !important;
            display: flex;
            justify-content: flex-end;
            .uik-prompt__confirm-button {
                margin-left: 15px;
            }
        }
        .uik-prompt__confirm-input {
            padding-top: 20px !important;
            padding-bottom: 35px !important;
        }
    }
</style>
